import styled from 'styled-components'

import { TreeSelect } from '../../../common/components/sections'

const StyledMenuTitleFilterTreeSelect = styled(TreeSelect)`
  width: 100%;
`

export default StyledMenuTitleFilterTreeSelect
